import { HttpError } from "@/utils/api"
import { getErrorNotificationKey } from "@/utils/notification-bridge"

const GENERIC_HTTP_ERROR_MESSAGE =
  /^(HTTP \d+|Unknown error|Unprocessable (Entity|Content)|Request failed with status code 422)$/i

const getCredentialSubmitDomainErrorKey = (
  error: unknown,
  kind: "create" | "update"
): string => {
  const status = error instanceof HttpError ? error.status : null

  if (status === 422) {
    return kind === "create"
      ? "admin.credentialsUi.createValidationError"
      : "admin.credentialsUi.updateValidationError"
  }

  return kind === "create"
    ? "admin.credentialsUi.createError"
    : "admin.credentialsUi.updateError"
}

export const getCredentialSubmitErrorKey = (
  error: unknown,
  kind: "create" | "update"
): string =>
  getErrorNotificationKey(error, getCredentialSubmitDomainErrorKey(error, kind))

export const getCredentialSubmitDetail = (error: unknown): string | null => {
  if (!(error instanceof HttpError) || error.status !== 422) {
    return null
  }

  const message = error.message.trim()
  if (message === "" || GENERIC_HTTP_ERROR_MESSAGE.test(message)) {
    return null
  }

  return message
}
